import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'minutesToHours'
})
export class MinutesToHoursPipe implements PipeTransform {
    transform(totalMinutes: number): string {
        if (isNaN(totalMinutes)) return '';

        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return `${hours}h\u00A0${minutes}m`;
    }
}
